import React, { useEffect, Component, useState } from "react";
import Button from "@mui/material/Button";
import Table from "react-bootstrap/Table";
import AddIcon from "@mui/icons-material/Add";
import "../../admin.css";
import { BsThreeDotsVertical } from "react-icons/bs";
import Sidebar from "../../SideNav/sideBar";
import Dropdown from "react-bootstrap/Dropdown";
import { OverlayTrigger, Popover } from "react-bootstrap";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Pagination,
  PaginationItem,
  Tabs,
  Tab,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MdRemoveRedEye, MdDelete, MdMode } from "react-icons/md";
import CustomSnackbar from "../../../Components/notify/Snackbar";
import { apiAdminConfig } from "../../../utils/api";
import Nodata from "../../../Components/nodata/Nodata";
import Popup from "../../../Components/popup/Popup";
import Loader from "../../../Components/Loader/Loader";
import PropTypes from "prop-types";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const Contant = () => {
  const navigate = useNavigate();
  const [data, setData] = React.useState([]);

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [query, setQuery] = useState("");
  const [filterState, setFilterState] = useState([]);
  const [filterCity, setfilterCity] = useState([]);
  const [filterdeptName, setfilterdeptName] = useState([]);
  const [snackData, setsnackdata] = React.useState({
    open: false,
    message: "",
    status: "",
  });
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
    const initialPage = Number(searchParams.get("page")) || 1;
  const [page, setPage] = React.useState(initialPage);
  const [pageCount, setPageCount] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [pageData, setPageData] = React.useState({});
  let tablehead = ["S/N", "Job ID", "Invoice ID", "Job Name", "Vehicle Name","Status", "Action"];
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  const handlePageChange = (event, value) => {
    setPage(value);
    setSearchParams({ page: value });
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
  };
  const fetchdata = async (search_value) => {
    // setLoading(true);
    await apiAdminConfig
      .get("api/auth/master/jobs/search", {
        params: {
          search:
    !search_value || search_value === ""
      ? 0
      : isNaN(search_value)
      ? search_value
      : search_value,
          per_page: pageSize,
          page: page,
          is_deleted: 1,
          status: "pending",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setPageCount(response?.data?.view_data?.meta?.last_page);
          setPageSize(response?.data?.view_data?.meta?.per_page);
          setPageData(response?.data?.view_data);

          setPosts(response?.data?.view_data?.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
      });
  };

  useEffect(() => {
        const handler = setTimeout(() => {
          setDebouncedSearch(search);
        }, 1000); 
    
        return () => {
          clearTimeout(handler); 
        };
      }, [search]);

  React.useEffect(() => {
    fetchdata();
  }, []);

  useEffect(() => {
          fetchdata(debouncedSearch);
        }, [debouncedSearch, page, pageSize]);

  const handleClose = () => {
    setOpen(false);
  };

  const updateStatus = async (id, status) => {
    setsnackdata({
      open: false,
      message: "",
      status: "success",
    });

    if (!status) {
      await apiAdminConfig
        .get(`api/auth/master/jobs/status/active/${id}`)
        .then((response) => {
          if (response && response?.status === 200) {
            fetchdata();
            setTimeout(() => {
              setsnackdata({
                open: true,
                message: response.data.message,
                status: "success",
              });
            }, 1000);
            // window.location.reload();
          }
        })
        .catch((error) => {
          console.log("error---->", error);
        });
    } else {
      await apiAdminConfig
        .get(`api/auth/master/jobs/status/deactive/${id}`)
        .then((response) => {
          if (response && response?.status === 200) {
            fetchdata();
            setTimeout(() => {
              setsnackdata({
                open: true,
                message: response.data.message,
                status: "success",
              });
            }, 1000);
            // window.location.reload();
          }
        })
        .catch((error) => {
          console.log("error---->", error);
        });
    }
  };

  //handle Delete function
  const handleDelete = async (id) => {
    setOpen(id);
  };

  // Get current Posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;

  //Change Page
  const paginate = (pagenumber) => {
    setCurrentPage(pagenumber);
  };

  const [age, setAge] = React.useState(10);
  const [selectOpen, setSelectOpen] = React.useState(false);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleSelectClose = () => {
    setSelectOpen(false);
  };

  const handleOpen = () => {
    setSelectOpen(true);
  };

 
  // console.log("pageDatapageData", pageData);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <CustomSnackbar value={snackData} />
          <Card
            sx={{
              boxShadow: "none!important",
              borderRadius: "20px!important",
              mt: 4,
            }}
          >
            <CardContent>
             
              <Stack
                direction="row"
                justifyContent="space-between"
                mb={8}
                mt={3}
              >
                <Box>
                  <Typography
                    component="h3"
                    sx={{
                      fontSize: "30px",
                      fontWeight: 500,
                      textTransform: "capitalize",
                    }}
                  >
                    Job Deleted
                  </Typography>
                </Box>
                {/* <Box>
                  <Button
                    variant="outlined"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      borderRadius: "15px",
                      padding: "0.875rem 1.5rem",
                      fontSize: "14px !important",
                      lineHeight: "1",
                    }}
                    startIcon={<AddIcon color="primary" />}
                    onClick={() => {
                      navigate(`/master/job/jobs/${value}/create`);
                    }}
                  >
                    Add Job
                  </Button>
                </Box> */}
              </Stack>
              <Stack
                direction="row"
                justifyContent="space-between"
                mb={2}
                mt={4}
                alignItems="center"
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography sx={{ fontSize: "13px" }}>Show</Typography>
                  <FormControl size="small">
                    <Select
                      sx={{ fontSize: "13px" }}
                      open={selectOpen}
                      onClose={handleSelectClose}
                      onOpen={handleOpen}
                      value={pageSize}
                      onChange={handlePageSizeChange}
                    >
                      <MenuItem sx={{ fontSize: "13px" }} value={10}>
                        10
                      </MenuItem>
                      <MenuItem sx={{ fontSize: "13px" }} value={25}>
                        25
                      </MenuItem>
                      <MenuItem sx={{ fontSize: "13px" }} value={50}>
                        50
                      </MenuItem>
                      <MenuItem sx={{ fontSize: "13px" }} value={100}>
                        100
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <Typography sx={{ fontSize: "13px" }}>entries</Typography>
                </Stack>
                <Box>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography sx={{ fontSize: "13px" }}>Search :</Typography>
                    <FormControl size="small">
                      <TextField
                        sx={{ fontSize: "13px" }}
                        size="small"
                        id="outlined-controlled"
                        // label="Controlled"
                        value={search}
                        onChange={(event) => {
                          setSearch(event.target.value);
                        }}
                      />
                    </FormControl>
                  </Stack>
                </Box>
              </Stack>
              <div>
                <Box sx={{ mt: 4, minHeight: "100%" }}>
                  {posts && posts.length !== 0 ? (
                    <Table size="lg" responsive>
                      <thead
                        style={{
                          // backgroundColor: "#F0F1F2",
                          color: "#fff",
                          padding: "10px",
                          backgroundColor: "#FF7534",
                          textAlign: "left",
                          width: "100%",
                        }}
                      >
                        <tr style={{ width: "100%" }}>
                          {tablehead.map((el, id) => {
                            return (
                              <th
                                key={id}
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  fontSize: "14px",
                                }}
                              >
                                {el}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody style={{ textAlign: "left", fontSize: "14px" }}>
                        {posts &&
                          posts?.map((el, id) => {
                            return (
                              <tr
                                key={id}
                                style={{
                                  fontSize: "14px",
                                }}
                              >
                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {(page - 1) * pageSize + (id + 1)}
                                </td>

                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el?.id || "N/A"}
                                </td>

                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el?.invoices?.[0]?.invoice_number || "N/A"}
                                </td>

                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el.name || "N/A"}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {(() => {
                                    try {
                                      const vehicleArray = JSON.parse(
                                        el?.vehicle || "[]"
                                      );
                                      return vehicleArray[0]?.trim() || "N/A";
                                    } catch (e) {
                                      return "N/A";
                                    }
                                  })()}
                                </td>

                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el?.status === 0
                                    ? "Pending"
                                    : el?.status === 1
                                    ? "Job Confirmed"
                                    : el?.status === 3
                                    ? "Job Started"
                                    : el?.status === 4
                                    ? "Job Completed"
                                    : el?.status === 2 ||
                                      (el?.status === 2 &&
                                        el?.created_by === "customer" &&
                                        el?.is_paid === 1)
                                    ? "Job Ready to Start"
                                    : el?.is_paid === 0 &&
                                      el?.created_by === "customer"
                                    ? "Waiting for Payment"
                                    : "N/A"}
                                </td>

                                {/* <td style={{ width: "20vh" }}>
                              {moment(el?.createdAt).format("DD/MM/YYYY")}
                            </td> */}
                                <td style={{ textAlign: "center" }}>
                                  <Dropdown>
                                    <OverlayTrigger
                                      rootClose
                                      trigger="click"
                                      placement="bottom"
                                      overlay={
                                        <Popover id="popover-basic">
                                          <Popover.Body>
                                            <Stack gap={2}>
                                              <Dropdown.Item
                                                onClick={(e) => {
                                                  navigate(
                                                    `/master/job/jobs/view/${el.id}`
                                                  );
                                                }}
                                              >
                                                <MdRemoveRedEye size={18} />{" "}
                                                View
                                              </Dropdown.Item>
                                              
                                              {/* <Dropdown.Item
                                                onClick={() => {
                                                  navigate(
                                                    `/master/job/jobs/${value}/${el?.id}`
                                                  );
                                                }}
                                              >
                                                <MdMode size={18} /> Edit
                                              </Dropdown.Item> */}
                                              <Dropdown.Item
                                                onClick={() => {
                                                  handleDelete(el.id);
                                                }}
                                              >
                                                <MdDelete size={18} /> Delete
                                              </Dropdown.Item>
                                            </Stack>
                                          </Popover.Body>
                                        </Popover>
                                      }
                                    >
                                      <Dropdown.Toggle
                                        variant="light"
                                        id="dropdown-basic"
                                      >
                                        <BsThreeDotsVertical />
                                      </Dropdown.Toggle>
                                    </OverlayTrigger>
                                  </Dropdown>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  ) : (
                    <div>
                      <Nodata />
                    </div>
                  )}
                </Box>
                <Box
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    padding: "0px",
                    borderTop: "0px",
                  }}
                >
                  <div className="justify-content-between flex-wrap d-flex align-items-center">
                    <Typography
                      className="footer-text"
                      sx={{ fontSize: "14px" }}
                    >
                      Showing {pageData?.from}-{pageData?.to} of{" "}
                      {pageData?.total} entries
                    </Typography>
                    <Pagination
                      count={pageCount}
                      color="primary"
                      page={page}
                      onChange={handlePageChange}
                      variant="outlined"
                      shape="rounded"
                      renderItem={(item) => (
                        <PaginationItem
                          slots={{
                            previous: () => {
                              return (
                                <Typography sx={{ fontSize: "14px" }}>
                                  Previous
                                </Typography>
                              );
                            },
                            next: () => {
                              return (
                                <Typography sx={{ fontSize: "14px" }}>
                                  Next
                                </Typography>
                              );
                            },
                          }}
                          {...item}
                        />
                      )}
                    />

                    {/* <TablePagination
                      sx={{ fontSize: "14px" }}
                      postsPerPage={postsPerPage}
                      totalPosts={posts.length}
                      paginate={paginate}
                    /> */}
                  </div>
                </Box>
                {open && (
                  <Popup
                    title="Add New Driver"
                    id={open}
                    handleClose={handleClose}
                    handleDelete={handleClose}
                    fetchdata={fetchdata}
                    setsnackdata={setsnackdata}
                    setOpen={setOpen}
                    actionURL="/api/auth/master/jobs/delete"
                  />
                )}
              </div>{" "}
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

class JobDeleted extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
    };
  }
  render() {
    return (
      <div>
        {this.state.windowWidth >= 600 ? (
          <Sidebar>
            <Contant />
          </Sidebar>
        ) : (
          <div style={{ width: "95%", margin: "80px auto" }}>
            {" "}
            <Contant />
          </div>
        )}
      </div>
    );
  }
}

export default JobDeleted;
